/* ============================================================
   Furqanwear fit finder
   Vanilla JS, no dependencies. Upload to Shopify: Assets/fit-finder.js

   PRINCIPLE: width is a hard constraint, length is a soft one.
   A thobe can be hemmed shorter but never lengthened, and it can
   never be let out through the chest, collar or shoulder. So when
   height and build disagree, this always resolves in favour of the
   body and reports how much to take off the hem.

   SET1 — numbered length (52-62) x lettered chest. Only M is stocked.
   SET2 — single lettered axis driven by height (XS-XXXL).
   ============================================================ */
(function () {
  "use strict";
  if (window.FurqanFit) return;

  /* ---------- SET1, M column (the only letter stocked) ---------- */
  /* Derived columns proven exact across the full 29-row spec sheet:
     waist = chestHalf | deepChest = chestHalf-0.5 | hip = +2
     bottom = +7 | fullCollar = halfCollar + 2.5                     */
  var SET1 = {
    50: { ch: 22.25, sh: 17.25, sl: 23.00, hc: 15.25 },
    52: { ch: 22.50, sh: 17.50, sl: 23.50, hc: 15.50 },
    54: { ch: 22.75, sh: 17.50, sl: 24.00, hc: 15.50 },
    56: { ch: 22.75, sh: 17.50, sl: 24.00, hc: 15.50 },
    58: { ch: 22.75, sh: 17.50, sl: 25.00, hc: 15.50 },
    60: { ch: 22.75, sh: 17.50, sl: 26.00, hc: 16.00 },
    62: { ch: 22.75, sh: 17.50, sl: 26.50, hc: 16.00 }
  };
  /* 50 is not on the supplier spec sheet — extrapolated one step below
     52 along the same gradient. Replace with real figures when you have
     a garment to measure. */
  var SET1_LENGTHS = [50, 52, 54, 56, 58, 60, 62];

  /* Supplier length -> the label the customer sees. Confirmed by Jahid. */
  var SET1_LABELS = {
    50: "XS", 52: "S", 54: "M", 56: "L", 58: "XL", 60: "XXL", 62: "XXXL"
  };

  /* One shared ladder for the whole store: a given height returns the
     same label whichever supplier the product came from. */
  var SIZE_LADDER = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"];

  /* ---------- SET2 widths. Not published by the supplier. Anchored on
     their model: 184cm / 91kg (est. 43.3" chest) wears their XL, which
     under our one-size-down relabelling is our L. Sitting our L at 51"
     gives him ~7.7" of room — a relaxed drape, consistent with an
     oversize line — and crucially the fit finder then returns L for him
     rather than bumping him a size past what he actually wears.
     Earlier figures were graded before the relabelling and ran ~2" low. */
  var SET2_CHEST = { XS: 45, S: 47, M: 49, L: 51, XL: 53, XXL: 55, XXXL: 57 };

  /* ---------- Body model. Recalibrate ANCHOR and SLOPE on returns ------ */
  var ANCHOR = 38.5;  // chest inches at 5'10" / 160lb
  var SLOPE  = 0.87;  // chest inches gained per BMI point
  var MIN_EASE = 3.5; // below this the garment is unwearable

  /* Plain clothing language for how the garment will actually wear,
     measured as inches of chest room between body and garment. */
  var FIT_SCALE = [
    { min: 10.0, name: "Oversized",   tone: "good" },
    { min: 8.0,  name: "Loose fit",   tone: "good" },
    { min: 6.0,  name: "Relaxed fit", tone: "good" },
    { min: 4.5,  name: "Regular fit", tone: "good" },
    { min: 3.0,  name: "Slim fit",    tone: "warn" },
    { min: 1.5,  name: "Tight fit",   tone: "warn" },
    { min: -99,  name: "Very tight",  tone: "bad"  }
  ];
  function fitOf(e) {
    for (var i = 0; i < FIT_SCALE.length; i++) if (e >= FIT_SCALE[i].min) return FIT_SCALE[i];
    return FIT_SCALE[FIT_SCALE.length - 1];
  }

  function body(hIn, wLb) {
    var bmi = (wLb * 703) / (hIn * hIn);
    var chest = Math.max(28, (ANCHOR + (bmi - 23) * SLOPE) * (hIn / 70));
    return { bmi: bmi, chest: chest, neck: chest * 0.375, shoulder: 0.245 * hIn + (bmi - 23) * 0.06 };
  }

  /* Inches between a customer's height and the length number that fits.
     THIS IS THE SINGLE MOST IMPORTANT NUMBER IN THE FILE. Raise it to
     make every recommendation shorter, lower it to make them longer.
     Set from two real fittings: 178cm wears M (54) and 180cm wears 54-56.
     Recalibrate against past orders before trusting it broadly. */
  var LENGTH_OFFSET = 16;

  /* Half-steps round upward: on a boundary, the longer thobe is the
     recoverable mistake, because a hem can be taken up. */
  function set1BaseLength(hIn) {
    var L = Math.round((hIn - LENGTH_OFFSET) / 2) * 2;
    if (L < 50) return 50;
    if (L > 62) return 62;
    return L;
  }
  var stepUp = function (L, n) {
    var i = Math.min(SET1_LENGTHS.indexOf(L) + n, SET1_LENGTHS.length - 1);
    return SET1_LENGTHS[i];
  };

  function set1Agent(b, hIn) {
    var base = set1BaseLength(hIn);
    var L = base, bellySteps = 0, fitSteps = 0, notes = [];

    /* Weight carried in front eats length off the hem. This is real
       extra length the customer needs, not surplus to cut off. */
    if (b.bmi >= 33) bellySteps = 2;
    else if (b.bmi >= 28) bellySteps = 1;
    L = stepUp(L, bellySteps);

    /* Collar only widens at 60/62. If the neck needs it, go there and
       hem the excess off — the collar cannot be altered, the hem can. */
    var afterBelly = L;
    if (b.neck + 0.75 > 18.00 && L < 60) L = 60;
    /* 52 is the one length cut narrower through the chest. */
    if (L === 52 && b.chest + 5 > 45.0) L = 54;
    fitSteps = SET1_LENGTHS.indexOf(L) - SET1_LENGTHS.indexOf(afterBelly);

    var g = SET1[L];
    var garmentChest = g.ch * 2;
    var ease = garmentChest - b.chest;
    var hemInches = L - afterBelly;

    /* Nothing in this line is cut wider through the chest, so when the
       body outgrows it the only lever left is more fabric overall. Go to
       the longest we carry and let them take the hem up. */
    var maxedOut = false;
    if (ease < MIN_EASE && L < 62) {
      L = 62;
      g = SET1[L];
      garmentChest = g.ch * 2;
      ease = garmentChest - b.chest;
      hemInches = L - afterBelly;
      maxedOut = true;
    }
    var fit = fitOf(ease);

    if (maxedOut) {
      notes.push("Moved to the largest size we carry. Every length in this " +
        "line is the same width through the chest, so this is as much room " +
        "as exists — take about " + hemInches + "\" off the hem to fit the length.");
    } else if (hemInches > 0) {
      notes.push("Sized up to " + L + " for the collar, not the height. Take about " +
        hemInches + "\" off the hem.");
    }
    if (hemInches > 0) {
      var slDelta = g.sl - SET1[afterBelly].sl;
      if (slDelta > 0) notes.push("Sleeve runs about " + slDelta.toFixed(1) +
        "\" long at this length and will need shortening too.");
    }
    if (bellySteps > 0) notes.push("Length already includes " + (bellySteps * 2) +
      "\" for build — the hem rides up in front. Don't cut this off.");
    if (hIn < 62.5) notes.push("Shorter than 50 covers. Expect a hem alteration.");
    if (b.shoulder > g.sh + 0.4) notes.push("Shoulder is " + g.sh.toFixed(2) +
      "\" and can't be let out. This build wants about " + b.shoulder.toFixed(1) + "\".");

    return {
      set: "set1", ok: true,
      size: SET1_LABELS[L] || L + " M",
      variant: SET1_LABELS[L] || L + " M",
      supplier: L + " M",
      fit: fit.name, tone: fit.tone,
      ease: ease, chest: b.chest, garment: garmentChest, hem: hemInches,
      notes: notes
    };
  }

  function set2Agent(b, hIn) {
    var base = SIZE_LADDER.indexOf(SET1_LABELS[set1BaseLength(hIn)]);
    if (base < 0) base = 2;
    var idx = base, notes = [];
    /* Unlike set 1, going up a letter here genuinely buys chest room. */
    while (idx < SIZE_LADDER.length - 1 && b.chest + 6 > SET2_CHEST[SIZE_LADDER[idx]]) idx++;

    var bumped = idx - base;
    var label = SIZE_LADDER[idx];
    var ease = SET2_CHEST[label] - b.chest;
    var hemCm = Math.max(0, bumped * 4 - (b.bmi >= 28 ? 4 : 0));

    if (bumped > 0) {
      notes.push("Sized up " + bumped + " for width, not height. This is the " +
        "only way to gain chest room in this range.");
      notes.push(hemCm > 0
        ? "Take roughly " + hemCm + "cm off the hem."
        : "The extra length is absorbed by the build — leave the hem alone.");
    }
    if (hIn * 2.54 < 160) notes.push("Shorter than XS covers. Hem will need taking up.");

    var fit = fitOf(ease);
    if (ease < MIN_EASE) notes.push("This is the largest size we carry. " +
      "It will sit close through the chest.");
    return {
      set: "set2", ok: true,
      size: label, variant: label, supplier: label,
      fit: fit.name, tone: fit.tone,
      ease: ease, chest: b.chest, garment: SET2_CHEST[label], hem: hemCm,
      notes: notes
    };
  }

  /* ---------- Variant matching -------------------------------------- */
  function normalise(s) {
    var t = String(s).toUpperCase().replace(/[^A-Z0-9]/g, "");
    /* 2XL and XXL are the same size written two ways, and this shop
       uses both spellings across product lines. */
    t = t.replace(/^([2-6])X([LS])$/, function (m, n, sz) {
      return new Array(+n + 1).join("X") + sz;
    });
    return t;
  }
  /* Products carry Size AND Colour, so a variant is titled "M / Black".
     Match on the size option alone, then keep whatever colour the
     customer already has selected rather than jumping them to another. */
  function currentVariant(variants) {
    var q = null;
    try { q = new URLSearchParams(window.location.search).get("variant"); } catch (e) {}
    if (!q) return null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(q)) return variants[i];
    }
    return null;
  }

  function findVariant(variants, label, sizeIdx) {
    if (!label) return null;
    var want = normalise(label);
    sizeIdx = sizeIdx || 0;

    var hits = [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = v.options || [];
      /* Fall back to the full title on single-option products. */
      var val = opts.length > sizeIdx ? opts[sizeIdx] : v.title;
      if (normalise(val) === want) hits.push(v);
    }
    if (!hits.length) return null;
    if (hits.length === 1) return hits[0];

    var cur = currentVariant(variants);
    if (cur && cur.options) {
      for (var j = 0; j < hits.length; j++) {
        var same = true;
        for (var k = 0; k < cur.options.length; k++) {
          if (k === sizeIdx) continue;
          if ((hits[j].options || [])[k] !== cur.options[k]) { same = false; break; }
        }
        if (same) return hits[j];
      }
    }
    for (var m = 0; m < hits.length; m++) if (hits[m].available) return hits[m];
    return hits[0];
  }

  /* ---------- UI ----------------------------------------------------- */
  function render(root) {
    var set = root.dataset.set || "set1";
    var variants = JSON.parse(root.dataset.variants || "[]");
    var sizeIdx = parseInt(root.dataset.sizeIndex, 10) || 0;
    /* Height and weight units are independent — plenty of people think in
       feet and kilos, or centimetres and pounds. State is always held in
       cm and kg; the units only change what's displayed. */
    var st = { hCm: 178, wKg: 72, hUnit: "cm", wUnit: "kg" };
    var current = null;

    root.innerHTML =
      '<button class="ff-open" type="button">' +
        '<span class="ff-open-ico" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">' +
          '<rect x="1.5" y="7" width="21" height="10" rx="1"/>' +
          '<path d="M6 7v3M10 7v4.5M14 7v3M18 7v4.5"/></svg>' +
        "</span>" +
        '<span class="ff-open-txt"><b>' +
          (root.dataset.label || "Find my size") + "</b><em>" +
          (root.dataset.sub || "Enter your height and weight \u2014 takes 10 seconds") +
        "</em></span>" +
        '<span class="ff-open-arw" aria-hidden="true">&rarr;</span>' +
      "</button>" +
      '<div class="ff-modal" hidden><div class="ff-box" role="dialog" aria-modal="true" aria-label="Find my size">' +
        '<button class="ff-close" type="button" aria-label="Close">&times;</button>' +
        '<h3 class="ff-h">Find my size</h3>' +

        '<div class="ff-row">' +
          '<div class="ff-rowhead"><label id="ff-hl">Height</label>' +
            '<div class="ff-toggle">' +
              '<button type="button" data-hu="cm" aria-pressed="true">cm</button>' +
              '<button type="button" data-hu="ftin" aria-pressed="false">ft / in</button>' +
            '</div></div>' +
          '<div class="ff-fields ff-hf"></div>' +
          '<input class="ff-hr" type="range" min="140" max="215" step="1" aria-labelledby="ff-hl">' +
        '</div>' +

        '<div class="ff-row">' +
          '<div class="ff-rowhead"><label id="ff-wl">Weight</label>' +
            '<div class="ff-toggle">' +
              '<button type="button" data-wu="kg" aria-pressed="true">kg</button>' +
              '<button type="button" data-wu="lb" aria-pressed="false">lb</button>' +
            '</div></div>' +
          '<div class="ff-fields ff-wf"></div>' +
          '<input class="ff-wr" type="range" min="40" max="200" step="1" aria-labelledby="ff-wl">' +
        '</div>' +

        '<div class="ff-out"></div>' +
        '<div class="ff-err" hidden></div>' +
        '<button class="ff-apply" type="button" hidden>Add this size to cart</button>' +
      '</div></div>';

    var $ = function (sel) { return root.querySelector(sel); };
    var box = function (f, v, min, max, unit) {
      return '<span class="ff-box-in"><input type="number" data-f="' + f +
        '" min="' + min + '" max="' + max + '" step="1" value="' + v +
        '" inputmode="numeric"><em>' + unit + "</em></span>";
    };

    function paintFields() {
      if (st.hUnit === "cm") {
        $(".ff-hf").innerHTML = box("hcm", Math.round(st.hCm), 120, 230, "cm");
      } else {
        var t = st.hCm / 2.54, f = Math.floor(t / 12), i = Math.round(t % 12);
        if (i === 12) { f++; i = 0; }
        $(".ff-hf").innerHTML = box("ft", f, 3, 7, "ft") + box("in", i, 0, 11, "in");
      }
      $(".ff-wf").innerHTML = st.wUnit === "kg"
        ? box("kg", Math.round(st.wKg), 30, 250, "kg")
        : box("lb", Math.round(st.wKg * 2.20462), 66, 550, "lb");
      $(".ff-hr").value = Math.round(st.hCm);
      $(".ff-wr").value = Math.round(st.wKg);
    }

    function syncSliders() {
      $(".ff-hr").value = Math.round(st.hCm);
      $(".ff-wr").value = Math.round(st.wKg);
    }

    function update() {
      var hIn = st.hCm / 2.54, wLb = st.wKg * 2.20462;
      var b = body(hIn, wLb);
      var r = set === "set2" ? set2Agent(b, hIn) : set1Agent(b, hIn);
      current = r;

      var html = "";
      html += '<div class="ff-label">Your size</div>';
      html += '<div class="ff-size">' + r.size + "</div>";
      html += '<div class="ff-fit ff-' + r.tone + '">' + r.fit + "</div>";
      html += '<div class="ff-reason">' + r.ease.toFixed(1) +
              '" of room through the chest</div>';
      if (r.notes.length) {
        html += "<ul class='ff-notes'>";
        for (var i = 0; i < r.notes.length; i++) html += "<li>" + r.notes[i] + "</li>";
        html += "</ul>";
      }
      $(".ff-out").innerHTML = html;

      var v = findVariant(variants, r.variant, sizeIdx);
      $(".ff-apply").hidden = !v;
      $(".ff-apply").dataset.vid = v ? v.id : "";
    }

    /* Typing must not repaint the field it's being typed into, or the
       caret jumps. Sliders repaint; keyboard entry only syncs. */
    root.addEventListener("input", function (e) {
      var t = e.target;
      if (t.classList.contains("ff-hr")) { st.hCm = +t.value; paintFields(); update(); return; }
      if (t.classList.contains("ff-wr")) { st.wKg = +t.value; paintFields(); update(); return; }
      var f = t.dataset.f;
      if (!f) return;
      if (f === "hcm") st.hCm = +t.value || st.hCm;
      else if (f === "kg") st.wKg = +t.value || st.wKg;
      else if (f === "lb") st.wKg = (+t.value || 0) / 2.20462 || st.wKg;
      else if (f === "ft" || f === "in") {
        var ft = +($('[data-f="ft"]') || {}).value || 0;
        var inch = +($('[data-f="in"]') || {}).value || 0;
        if (ft) st.hCm = (ft * 12 + inch) * 2.54;
      }
      syncSliders();
      update();
    });

    root.addEventListener("click", function (e) {
      var t = e.target, hu = t.dataset.hu, wu = t.dataset.wu;
      if (!hu && !wu) return;
      var key = hu ? "hu" : "wu";
      var nodes = root.querySelectorAll("[data-" + key + "]");
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].setAttribute("aria-pressed", nodes[i] === t ? "true" : "false");
      }
      if (hu) st.hUnit = hu; else st.wUnit = wu;
      paintFields();
      update();
    });

    $(".ff-open").addEventListener("click", function () {
      $(".ff-modal").hidden = false; paintFields(); update();
    });
    $(".ff-close").addEventListener("click", function () { $(".ff-modal").hidden = true; });

    $(".ff-apply").addEventListener("click", function () {
      var btn = this, vid = btn.dataset.vid;
      if (!vid) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding\u2026";
      $(".ff-err").hidden = true;

      function fail(msg) {
        btn.disabled = false;
        btn.textContent = label;
        $(".ff-err").textContent = msg;
        $(".ff-err").hidden = false;
      }

      /* Straight to the Cart AJAX API. Selecting the variant in the
         theme's own picker was unreliable — Horizon keeps it in Shadow
         DOM — and it never actually added anything. The underscore keeps
         the property off the customer's cart while still recording it on
         the order in admin. */
      var props = {};
      props["_fit_recommendation"] = current.size + " | " + current.fit +
        " | ease " + current.ease.toFixed(1) + '" | hem ' + current.hem;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(vid), quantity: 1, properties: props }]
        })
      })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, data: d }; });
        })
        .then(function (res) {
          if (!res.ok) {
            fail((res.data && res.data.description) ||
                 "That size is out of stock right now.");
            return;
          }
          window.location.href = "/cart";
        })
        .catch(function () {
          fail("Couldn't add to cart. Please choose your size above.");
        });
    });
  }

  /* ---------- Auto-mount ---------------------------------------------
     Locked-down themes won't accept a custom block in the product
     section, so the container is emitted at the end of <body> and
     relocated here. Only ever moved into the light DOM — dropping it
     inside a shadow root would cut it off from the stylesheet. */
  function deepFind(sel, root, depth) {
    root = root || document; depth = depth || 0;
    if (depth > 6) return null;
    var hit = root.querySelector(sel);
    if (hit) return hit;
    var all = root.querySelectorAll("*");
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var d = deepFind(sel, all[i].shadowRoot, depth + 1);
        if (d) return d;
      }
    }
    return null;
  }

  /* Ordered by preference. The add-to-cart button is the anchor we want:
     inserting before it lands the block under the swatches and directly
     above Add to cart, which is where a size question actually occurs.
     Earlier versions matched the whole form and landed above the price. */
  /* Preferred anchors, first match wins. The size-chart trigger is the
     natural neighbour: a customer reaching for the chart is asking the
     exact question this answers, so we sit immediately after it and
     above the swatches. Add-to-cart is the fallback. */
  var MOUNT_TARGETS = [
    { sel: "[data-size-chart]", pos: "after" },
    { sel: ".size-chart", pos: "after" },
    { sel: ".size-guide", pos: "after" },
    { sel: "[href*='size-chart']", pos: "after" },
    { sel: "[href*='size-guide']", pos: "after" },
    { sel: "modal-opener", pos: "after" },
    { sel: 'button[name="add"]', pos: "before" },
    { sel: ".product-form__buttons", pos: "before" },
    { sel: 'form[action*="/cart/add"]', pos: "before" }
  ];

  /* Some themes label the chart trigger only in its text. */
  function findByText(words) {
    var els = document.querySelectorAll("button, a, summary, [role=button]");
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || "").trim().toLowerCase();
      if (t.length > 40) continue;
      for (var j = 0; j < words.length; j++) {
        if (t.indexOf(words[j]) !== -1) return els[i];
      }
    }
    return null;
  }

  function autoMount(node) {
    if (node.dataset.mounted) return;

    /* Walk up while this element is the only child, so we land beside the
       whole control rather than inside its wrapper — but never climb past
       a parent that also holds the size options. */
    function outermost(t) {
      while (t.parentNode && t.parentNode.children.length === 1 &&
             t.parentNode.getRootNode() === document &&
             t.parentNode.tagName !== "BODY") t = t.parentNode;
      return t;
    }

    /* Preferred: sit in the gap between the size-chart trigger and the
       size options, which is exactly where the question gets asked. */
    function betweenChartAndSizes() {
      var chart = null;
      var sels = ["[data-size-chart]", ".size-chart", ".size-guide",
                  "[href*='size-chart']", "[href*='size-guide']"];
      for (var i = 0; i < sels.length && !chart; i++) chart = deepFind(sels[i]);
      if (!chart) chart = findByText(["size chart", "size guide", "sizing"]);
      if (!chart) return false;
      chart = outermost(chart);

      /* Find the size picker among the chart button's later siblings and
         insert immediately before it. Falls back to just after the chart. */
      var sib = chart.nextElementSibling;
      while (sib) {
        var txt = (sib.textContent || "").toLowerCase();
        if (txt.indexOf("size") !== -1 &&
            (sib.querySelector("input,label,button,select,fieldset") || /size\s*:/.test(txt))) {
          sib.parentNode.insertBefore(node, sib);
          node.dataset.mounted = "1";
          return true;
        }
        sib = sib.nextElementSibling;
      }
      chart.parentNode.insertBefore(node, chart.nextSibling);
      node.dataset.mounted = "1";
      return true;
    }

    if (node.dataset.mount) {
      var t0 = deepFind(node.dataset.mount);
      if (t0 && t0.getRootNode() === document && t0.parentNode) {
        t0 = outermost(t0);
        t0.parentNode.insertBefore(node,
          node.dataset.mountPos === "after" ? t0.nextSibling : t0);
        node.dataset.mounted = "1";
        return;
      }
    }

    if (betweenChartAndSizes()) return;

    var fallback = ['button[name="add"]', ".product-form__buttons",
                    'form[action*="/cart/add"]'];
    for (var i = 0; i < fallback.length; i++) {
      var t = deepFind(fallback[i]);
      if (t && t.getRootNode() === document && t.parentNode) {
        t.parentNode.insertBefore(node, t);
        node.dataset.mounted = "1";
        return;
      }
    }
    node.dataset.mounted = "fallback";
  }

  function init() {
    var nodes = document.querySelectorAll("[data-fit-finder]");
    for (var i = 0; i < nodes.length; i++) if (!nodes[i].dataset.ready) {
      nodes[i].dataset.ready = "1";
      if (nodes[i].hasAttribute("data-auto-mount")) autoMount(nodes[i]);
      render(nodes[i]);
    }
  }
  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("load", init);
  setTimeout(init, 1200);
  document.addEventListener("shopify:section:load", init);
  window.FurqanFit = { body: body, set1: set1Agent, set2: set2Agent };
})();